import React from "react";
import withStyles from "components/with-styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import styles from "./styles/page-footer-wrapper.css.js";

const Wrapper = ({ children, classes }) => (
  <AppBar position="fixed" color="primary" className={classes.page_footer}>
    <Toolbar className={classes.page_footer_toolbar}>{children}</Toolbar>
  </AppBar>
);

export default withStyles(styles)(Wrapper);
